import { render, staticRenderFns } from "./DesignSkinList.vue?vue&type=template&id=0ff4b9de&"
import script from "./DesignSkinList.vue?vue&type=script&lang=ts&"
export * from "./DesignSkinList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports